import template from './mx-query-filter-toolbar.component.html';
import { EventCodes } from '../../../../App/model/event-codes';

export class MxQueryFilterToolbarController {
	static $inject = ['$scope', 'mx.shell.SearchProviderService', 'mx.SolutionBuilderAgent.SearchQueryService', 'mx.shell.EventService', '$element'];

	searchQueryService;
	searchService;
	$element;
	debouncedCheckMoreBtnVisibility;
	uiToken;
	filters = [];
	viewParameters;

	constructor($scope, searchService, searchQueryService, eventService, $element) {
		this.searchQueryService = searchQueryService;
		this.searchService = searchService;
		this.eventService = eventService;
		this.$element = $element;

		this.debouncedCheckMoreBtnVisibility = $.debounce(100, () => {
			$scope.$evalAsync(() => {
				if (this.containerEl.is(':visible')) {
					this.showMoreButton = this.containerEl.height() > 35;
					this.morePanelTopOffset = this.containerEl.position().top + 35;
				} else {
					this.showMorePanel = false;
				}
			});
		});

		eventService.subscribeTo(mx.shell.EventCodes.LayoutChanged, this.debouncedCheckMoreBtnVisibility, $scope);

		eventService.subscribeTo(
			mx.shell.EventCodes.Search,
			(event, so) => {
				if (so.uiToken !== this.uiToken) {
					return;
				}
				const filters = so?.filters || [];
				this.queries.forEach((query) => {
					query.__active = filters.indexOf(query.id) >= 0;
				});
			},
			$scope
		);
	}

	$onInit() {
		const context = this.searchService.currentContext();

		this.searchQueryService.getQueries(context).then((queries) => {
			this.queries = (queries || []).filter((query) => !query.showInNavigation);

			this.debouncedCheckMoreBtnVisibility();
		});
	}

	toggleQueryFilter(query) {
		query.__active = !query.__active;
		if (query.__active) {
			this.trackTelemetry(query);
		}
		this.runQuery();
	}

	trackTelemetry(query) {
		this.eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: 'Search filter applied from grid',
			sender: `${this.viewParameters.id}_${query.id}`,
			senderTitle: `${this.viewParameters.name}_${query.title}`,
			contextTypeId: this.viewParameters.entities.map((entity) => entity.id),
			contextTypeTitle: this.viewParameters.entities.map((entity) => entity.name),
		});
	}

	clearFilters() {
		this.queries.forEach((query) => {
			query.__active = false;
		});
		this.runQuery();
	}

	runQuery() {
		const currentSearch = this.searchService.currentSearch();

		const currentBaseFilter = this.searchService.getBaseQueryId();

		currentSearch.filters = this.queries.filter((query) => query.__active).map((query) => query.id);

		if (currentBaseFilter && currentSearch.filters.indexOf(currentBaseFilter) < 0) {
			currentSearch.filters.push(currentBaseFilter);
		}

		this.searchService.runSearch();
	}

	$postLink() {
		this.containerEl = this.$element.find('.mx-query-filter-toolbar-container');
	}
}

angular.module('mx.SolutionBuilderAgent').component('mxQueryFilterToolbar', {
	bindings: {
		uiToken: '@',
		viewParameters: '<',
	},
	controller: MxQueryFilterToolbarController,
	controllerAs: 'vm',
	template: template,
});
